<template>
  <filter-wrapper v-model="form.search" @submit="submit" />
</template>

<script>
  import FilterWrapper from '@shared/components/filter-search';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper
    },
    data: () => ({
      form: {
        search: ''
      }
    }),

    methods: {
      ...mapActions('db/databases/show/recipients', ['search']),

      submit: function() {
        this.search(this.form);
      }
    }
  };
</script>
